import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useParams, useLocation } from 'react-router-dom';
import { useApp } from './context/AppContext';
import NovaPresenceBar from './components/NovaPresenceBar';
import Landing from './pages/Landing';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import NovaChat from './pages/NovaChat';
import Journey from './pages/Journey';
import MyDoctors from './pages/MyDoctors';
import Waitlist from './pages/Waitlist';
import About from './pages/About';
import ChapterPage from './pages/ChapterPage';
import TTCChapterPage from './pages/TTCChapterPage';
import FertilityChapterPage from './pages/FertilityChapterPage';
import PregnancyChapterPage from './pages/PregnancyChapterPage';
import MotherhoodChapterPage from './pages/MotherhoodChapterPage';
import ChapterDemo from './pages/ChapterDemo';
import Pricing from './pages/Pricing';
import Blog from './pages/Blog';
import BlogWhyICreatedOrivonai from './pages/BlogWhyICreatedOrivonai';
import BlogJournalLayoutStub from './pages/BlogJournalLayoutStub';
import Contact from './pages/Contact';
import Community from './pages/Community';
import WomenLikeMe from './pages/WomenLikeMe';
import Room from './pages/Room';
import LiveRoom from './pages/LiveRoom';
import HealthRecord from './pages/HealthRecord';
import Medications from './pages/Medications';
import Profile from './pages/Profile';
import FinancialTracker from './pages/FinancialTracker';
import { DEMO_NAV_CHAPTER_KEY } from './utils/demoNavContext';
function DemoRedirect({ children }) {
  return children;
}

function RedirectToDemoHome() {
  const { chapter } = useParams();
  return <Navigate to={`/demo/${chapter}/home`} replace />;
}

export default function AppShell() {
  const location = useLocation();
  const { novaPresenceBar, dismissNovaPresenceBar } = useApp();
  const inChapterDemo = location.pathname.startsWith('/demo');
  const showNovaPresenceBar = Boolean(novaPresenceBar && inChapterDemo);

  useEffect(() => {
    const p = location.pathname;
    if (!p.startsWith('/demo')) {
      dismissNovaPresenceBar();
    }
    const dm = p.match(/^\/demo\/([^/]+)/);
    if (dm) {
      sessionStorage.setItem(DEMO_NAV_CHAPTER_KEY, dm[1]);
    } else if (!p.startsWith('/nova')) {
      sessionStorage.removeItem(DEMO_NAV_CHAPTER_KEY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only clear when route leaves /demo/*
  }, [location.pathname]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {showNovaPresenceBar && (
        <NovaPresenceBar
          contextPill={novaPresenceBar.contextPill}
          message={novaPresenceBar.message}
          actionLabel={novaPresenceBar.actionLabel}
          onAction={novaPresenceBar.onAction}
          onDismiss={() => {
            if (novaPresenceBar.dismissStorageKey && typeof window !== 'undefined') {
              sessionStorage.setItem(novaPresenceBar.dismissStorageKey, '1');
            }
            dismissNovaPresenceBar();
          }}
        />
      )}
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/journey" element={<Journey />} />
          <Route path="/financial" element={<FinancialTracker />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/community" element={<Community />} />
          <Route path="/health" element={<HealthRecord />} />
          <Route path="/doctors" element={<MyDoctors />} />
          <Route path="/medications" element={<Medications />} />
          <Route path="/nova-chat" element={<NovaChat />} />
          <Route path="/connect" element={<WomenLikeMe />} />
          <Route path="/blog/why-i-created-orivonai" element={<BlogWhyICreatedOrivonai />} />
          <Route path="/blog/journal-layout-stub" element={<BlogJournalLayoutStub />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/resources" element={<Dashboard />} />
          <Route path="/chapter/cycle" element={<Navigate to="/chapter/ttc" replace />} />
          <Route path="/chapter/menopause" element={<Navigate to="/" replace />} />
          <Route path="/chapter/ttc" element={<TTCChapterPage />} />
          <Route path="/chapter/fertility" element={<FertilityChapterPage />} />
          <Route path="/chapter/pregnancy" element={<PregnancyChapterPage />} />
          <Route path="/chapter/motherhood" element={<MotherhoodChapterPage />} />
          <Route path="/chapter/postpartum" element={<Navigate to="/chapter/motherhood" replace />} />
          <Route path="/chapter/:chapter" element={<ChapterPage />} />
          <Route path="/demo/cycle/*" element={<Navigate to="/demo/ttc/home" replace />} />
          <Route path="/demo/first-chapter/*" element={<Navigate to="/demo/ttc/home" replace />} />
          <Route path="/demo/menopause/*" element={<Navigate to="/demo/postpartum/home" replace />} />
          <Route path="/demo/:chapter/profile/:username" element={<DemoRedirect><ChapterDemo /></DemoRedirect>} />
          <Route path="/demo/:chapter/:section" element={<DemoRedirect><ChapterDemo /></DemoRedirect>} />
          <Route path="/demo/:chapter" element={<RedirectToDemoHome />} />
          <Route path="/signin" element={<Navigate to="/signup?source=signin-redirect" replace />} />
          <Route path="/signup" element={<Waitlist />} />
          <Route path="/nova" element={<NovaChat />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/social" element={<Community />} />
          <Route path="/rooms/:roomId" element={<Room />} />
          <Route path="/live/:roomId" element={<LiveRoom />} />
          <Route path="/connections" element={<Navigate to="/community" replace />} />
          <Route path="/events" element={<Dashboard />} />
          <Route path="/products" element={<Dashboard />} />
          <Route path="/profile/:identifier" element={<Profile />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
